
import DnArticle from '~/patterns/organisms/article/article.vue';

export default {
    components: {
        DnArticle
    },

    props: {
        text: {
            type: String,
            required: true,
            default: ''
        }
    }
};
